import { makeActionCreator } from 'app/utils/redux';
import {
  SET_VALIDATION_ERRORS,
  CLEAR_VALIDATION_ERRORS,
  SET_SOURCE_VISIBLE,
} from 'app/models/validations/constants';

export const setValidationErrors =
  makeActionCreator(SET_VALIDATION_ERRORS, 'source', 'rootID', 'errors');

export const clearValidationErrors =
  makeActionCreator(CLEAR_VALIDATION_ERRORS, 'source', 'rootID');

export const setSourceVisible =
  makeActionCreator(SET_SOURCE_VISIBLE, 'source', 'visible');
